// extracted by mini-css-extract-plugin
export default {"main":"Partners_main__1l6pu","background":"Partners_background__A8KUu"};